<template>
    <v-dialog max-width="500" v-model="visible">
        <!-- <v-tooltip bottom> -->
            <!-- <template v-slot:activator="{ on }">
                <v-btn color="green" x-small dark fab v-on="on" >
                    <v-icon >print</v-icon>
                </v-btn> 
            </template> -->
            <template v-slot:activator="{ on }">
                <v-chip v-on="on" dark color="orange" label x-small>Modificar Vencimientos</v-chip>
            </template>
            <!-- Imprimir Documentación -->
        <!-- </v-tooltip> -->
        <v-card flat>
            <v-toolbar>
                <v-icon color="orange">calendar_today</v-icon>
                <v-toolbar-title class="font-weight-light">
                    <v-row>
                        <v-col >
                            <div>&nbsp;Modificación de Vencimientos </div>
                        </v-col>
                    </v-row>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.stop="visible=false"><v-icon>close</v-icon></v-btn>                    
            </v-toolbar>
            <v-card-text>
                <v-container fluid>                    
                    <v-row>
                        <v-col>
                            <v-text-field v-model="cantMeses" label="Cantidad de Meses" type="number"></v-text-field>
                        </v-col>
                        <v-col>
                            <v-radio-group v-model="adelantar" :mandatory="true">
                                <v-radio v-bind:value="true">
                                    <div slot="label">Adelantar</div>
                                </v-radio>
                                <v-radio v-bind:value="false">
                                    <div slot="label">Posponer</div>
                                </v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                    
                </v-container>
            </v-card-text>

            <v-divider></v-divider>  
            <v-card-actions>
                <v-btn color="blue darken-1" text @click.stop="visible=false" :disabled="loading">Cerrar</v-btn>
                <v-spacer></v-spacer>                
                
                <v-btn  color="blue darken-1" text @click.stop="modificar()" :disabled="loading">Confirmar Modificación</v-btn>                
            </v-card-actions>
        </v-card>

        <app-loading :loading="loading"></app-loading>

        <template v-if="$store.state.debugModeOn">
            Debug Info: <p></p>
            
            Model: {{cantMeses}}  {{adelantar}} <p></p>
        </template>
    </v-dialog>
</template>

<script>

import Vue from 'vue'
import { http } from '@/axios'
import axios from 'axios'

import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
    data: () => ({        
            loading: false,
            cantMeses: 0,
            adelantar: true,
            visible:false
        }
    ),
    props:{
        creditoId: { type: String },
        empresaId: { type: Number }
    },
    computed: {
        ...mapGetters(['getActionFromLink','user','DebugModeOn']),
        show: {
            get () {
                return this.visible
            },
            set (value) {
                if (!value) {
                    this.$emit('close')
                }
            }
        }
    },
    watch:{
        visible: function(){
            if(this.visible){
                //this.loadFormularios();
            }
        },        
    },
    methods:{
    ...mapMutations(["setActiveTask", "setActiveSubTask", "hideActiveTask", "hideActiveSubTask","setReporteActivo",
                        "alertClear", "alertSuccess", "alertWarning", "alertError"]),    
    async modificar(){
        if(!this.cantMeses || this.cantMeses <= 0)
        {
            this.alertWarning('Ingrese una cantidad de meses válida.')
            return;
        }

        var stringMeses = this.cantMeses + ' ' + (this.cantMeses > 1 ? ' meses' : ' mes');

        if(confirm('¿Desea ' + (this.adelantar ? 'adelantar' : 'posponer') + ' los vencimientos pendientes del crédito en ' + stringMeses + '?'))
        {
            this.loading = true;
            
            try {
                var params = {};
                params.creditoId = this.creditoId;
                params.cantMeses = this.cantMeses;
                params.adelantar = this.adelantar;

                var result = await http.post('creditos/updatevencimientos', JSON.stringify( {parametros:  params} ) );

                this.alertSuccess('Los cambios han sido registrados.');
            } catch (error) {
                // Error            
                this.alertError(error)
            }

            this.loading = false
        }  
    }
  }
}
</script>
